<template>
  <edit-pattern-filter
    v-if="selectedDomain.id"
    :id="selectedDomain.id"
    :tier="TIER.domains"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import EditPatternFilter from "@/views/Common/PatternFilters/Edit/Multi.vue";

import { TIER } from "@/constants";

export default {
  name: "EditAttachmentFilterWrapper",
  components: {
    EditPatternFilter,
  },
  data() {
    return {
      TIER,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(
      this.$t("Edit Pattern: X", { id: this.$route.params.id })
    );
    this.setPageSubtitle([]);
  },
};
</script>
